export default __webpack_public_path__ + "static/media/pic6.34372375.jpg";